import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    background: "#fff",
    zIndex: 999,
    opacity: 0.9,
    position: "fixed",
  },
}));

export const Loader = (props) => {
  const classes = useStyles();
  const styles = props.isModal
    ? {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
      }
    : {
        width: "100vw",
        height: "100vh",
      };

  return (
    <div className={classes.root} style={styles}>
      <CircularProgress disableShrink size={75} />
    </div>
  );
};
